if ('serviceWorker' in navigator) {
    window.addEventListener('load', function() {
        navigator.serviceWorker.register('/service-worker.js').then(function(registration) {
            // Registration was successful
            // console.log('ServiceWorker registration successful with scope: ', registration.scope);
        }, function(err) {
            // registration failed :(
            // console.log('ServiceWorker registration failed: ', err);
        });
    });
}

$(document).ready(function () {
    // show install prompt if wasn't dismissed
    function showPwaAdverts() {
        if (!Cookies.get('app_install_modal_dismiss')) {
            $('.app_install_modal').show();

            // show related copy
            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                $('.app_install_modal .app_copy_ios').show();
            } else {
                $('.app_install_modal .app_copy_android').show();
            }
        }
    }

    // Progressive Web App Install Prompt
    let pwaInstallDeferredPrompt;

    // Automatic event sent by browser if pwa was detected and not installed todo: firefox not firing this event
    window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        // Stash the event so it can be triggered later.
        pwaInstallDeferredPrompt = e;
        showPwaAdverts();
    });

    // hack to show on iOS (which not trigger 'beforeinstallprompt')
    if(/iPhone|iPad|iPod/i.test(navigator.userAgent) ) {
        showPwaAdverts();
    }

    $(document).on('click', '.pwa_install_trigger', function () {
        if(pwaInstallDeferredPrompt) {
            // Show the native prompt
            pwaInstallDeferredPrompt.prompt();
            // Wait for the user to respond to the prompt
            pwaInstallDeferredPrompt.userChoice
                .then((choiceResult) => {
                    if (choiceResult.outcome === 'accepted') {
                        // PWA setup accepted
                        $('.app_advert_wrap').hide();
                    } else {
                        // PWA setup rejected
                    }
                    pwaInstallDeferredPrompt = null;
                });
        }
        // iOS case
        else if(/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            window.location.href = 'https://apps.apple.com/be/app/zjedz-my/id1595819708';
        } else{
            Swal.fire({
                icon: 'warning',
                title: 'Wygląda na to, że masz już zainstalowaną aplikację',
                toast: true,
                position: 'top-start',
                showConfirmButton: false,
                timer: 3000,
            });
        }
    });

    // hide all app advert and modals if running pwa
    if((window.navigator.standalone == true) || (window.matchMedia('(display-mode: standalone)').matches)){
        $('.app_advert_wrap').hide();
    }

    // dismiss app modal event
    $('.app_install_modal_dismiss').click(function(){
        Cookies.set('app_install_modal_dismiss', 'true', { expires: 7 })
    });
});